import React, { FC } from 'react';

import { Box, Container, Typography, Divider } from '@mui/material';

const ZellerInfo: FC = () => {
  return (
    <Box
      py={12}
      sx={{
        background: 'linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <Container maxWidth="lg">
        <Box display="flex" flexDirection="column" alignItems="center" gap={6} position="relative" zIndex={2}>
          <Box textAlign="center" maxWidth="800px">
            <Typography
              variant="h2"
              sx={{
                fontFamily: 'Roboto',
                fontWeight: 800,
                fontSize: '45px',
                lineHeight: '50px',
                textAlign: 'center',
                py: 3,
              }}
            >
              Sobre Nosotros
            </Typography>
            <Divider
              sx={{
                width: '80px',
                margin: '0 auto',
                borderColor: '#47BCD8',
                borderWidth: 2,
                mb: 4,
              }}
            />
          </Box>

          <Box
            maxWidth="1200px"
            sx={{
              display: 'grid',
              gap: 3,
            }}
          >
            <Typography
              variant="body1"
              sx={{
                fontFamily: 'Roboto',
                fontSize: { xs: '16px', md: '18px' },
                lineHeight: '1.8',
                textAlign: 'center',
                color: '#2C5889',
              }}
            >
              Somos expertos en la optimización de procesos para la industria automotriz, integrando nuestro software de
              manera flexible y eficiente en concesionarios.
            </Typography>

            <Typography
              variant="body1"
              sx={{
                fontFamily: 'Roboto',
                fontSize: { xs: '16px', md: '18px' },
                lineHeight: '1.8',
                textAlign: 'center',
                color: '#2C5889',
              }}
            >
              Nuestra misión es impulsar la transformación digital de nuestros clientes a través de soluciones basadas
              en Inteligencia Artificial, optimizando la gestión de leads, la comunicación y las ventas de forma
              automatizada.
            </Typography>

            <Typography
              variant="body1"
              sx={{
                fontFamily: 'Roboto',
                fontSize: { xs: '16px', md: '18px' },
                lineHeight: '1.8',
                textAlign: 'center',
                color: '#2C5889',
              }}
            >
              Mejoramos tus ventas, entregamos la mejor atención al cliente, optimizamos financiamientos y campañas, y
              nos adaptamos a las necesidades específicas de cada uno de nuestros clientes.
            </Typography>
          </Box>
        </Box>
      </Container>

      {/* Elementos decorativos de fondo */}
      <Box
        sx={{
          position: 'absolute',
          top: '10%',
          left: '-5%',
          width: '200px',
          height: '200px',
          background: 'radial-gradient(circle, rgba(71, 188, 216, 0.1) 0%, rgba(71, 188, 216, 0) 70%)',
          borderRadius: '50%',
          zIndex: 1,
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          bottom: '10%',
          right: '-5%',
          width: '300px',
          height: '300px',
          background: 'radial-gradient(circle, rgba(44, 88, 137, 0.1) 0%, rgba(44, 88, 137, 0) 70%)',
          borderRadius: '50%',
          zIndex: 1,
        }}
      />
    </Box>
  );
};

export default ZellerInfo;
